import { render, staticRenderFns } from "./pageContentConfig.vue?vue&type=template&id=32be9640&scoped=true"
import script from "./pageContentConfig.vue?vue&type=script&lang=ts"
export * from "./pageContentConfig.vue?vue&type=script&lang=ts"
import style0 from "./pageContentConfig.vue?vue&type=style&index=0&id=32be9640&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32be9640",
  null
  
)

export default component.exports